module.exports = __webpack_public_path__ + "img/20191213165032835.d155b8e6.jpg";